import React, { useState, useEffect } from "react";
import FormAction from "./formAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
function References(props) {
  const [state, setState] = useState({
    formData: {
      percent_completed: 95,
      waive_rights: null,
      first_academic_reference_name: "",
      second_academic_reference_name: "",
      first_academic_reference_email: "",
      first_academic_reference_note: "",
      second_academic_reference_email: "",
      second_academic_reference_note: "",
      first_bayan_reference_name: "",
      first_bayan_reference_email: "",
      first_bayan_reference_note: "",
      second_bayan_reference_name: "",
      second_bayan_reference_email: "",
      second_bayan_reference_note: "",
    },
    waive_rightsValid: "",
    first_academic_reference_nameValid: "",
    first_academic_reference_emailValid: "",
    second_academic_reference_nameValid: "",
    second_academic_reference_emailValid: "",
    first_bayan_reference_nameValid: "",
    first_bayan_reference_emailValid: "",
    second_bayan_reference_nameValid: "",
    second_bayan_reference_emailValid: "",
    isFormDataValid: false,
  });

  const numberInputs = {};
  const stepFields = [
    "waive_rights",
    "first_academic_reference_email",
    "first_academic_reference_note",
    "second_academic_reference_email",
    "second_academic_reference_note",
    "first_bayan_reference_email",
    "first_bayan_reference_note",
    "second_bayan_reference_note",
  ];

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      selectedProgramId: state.applicationReducer.selectedProgramId,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!savedSteps.references) {
      populateForm();
    }
  }, []);

  useEffect(() => {
    validateForm();
  }, [state]);

  function populateForm() {
    const referencesData = savedSteps.references;
    if (!!savedSteps.references && Object.keys(referencesData).length > 0) {
      updateForm("waive_rights", referencesData.waive_rights);
      updateForm(
        "first_academic_reference_name",
        referencesData.first_academic_reference_name
      );
      updateForm(
        "first_academic_reference_email",
        referencesData.first_academic_reference_email
      );
      updateForm(
        "first_academic_reference_note",
        referencesData.first_academic_reference_note
      );
      updateForm(
        "second_academic_reference_name",
        referencesData.second_academic_reference_name
      );
      updateForm(
        "second_academic_reference_email",
        referencesData.second_academic_reference_email
      );
      updateForm(
        "second_academic_reference_note",
        referencesData.second_academic_reference_note
      );
      updateForm(
        "first_bayan_reference_name",
        referencesData.first_bayan_reference_name
      );
      updateForm(
        "first_bayan_reference_email",
        referencesData.first_bayan_reference_email
      );
      updateForm(
        "first_bayan_reference_note",
        referencesData.first_bayan_reference_note
      );
      updateForm(
        "second_bayan_reference_name",
        referencesData.second_bayan_reference_name
      );
      updateForm(
        "second_bayan_reference_email",
        referencesData.second_bayan_reference_email
      );
      updateForm(
        "second_bayan_reference_note",
        referencesData.second_bayan_reference_note
      );
      setState({
        ...state,
        waive_rightsValid: true,
        first_academic_reference_nameValid: true,
        second_academic_reference_nameValid: true,
        first_academic_reference_emailValid: true,
        second_academic_reference_emailValid: true,
        first_bayan_reference_nameValid: true,
        first_bayan_reference_emailValid: true,
        second_bayan_reference_nameValid: true,
        second_bayan_reference_emailValid: true,
        isFormDataValid: true,
      });
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData;
    temp[field] = value;
    setState((prevState) => ({ ...prevState, formData: temp }));
    _validate(field);
  };
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch (field) {
      case "waive_rights":
        regex = /^.{1,}/;
        valid = regex.test(value);
        break;
      case "first_academic_reference_name":
      case "second_academic_reference_name":
      case "first_bayan_reference_name":
      case "second_bayan_reference_name":
        regex = /^.{2,}/;
        valid = regex.test(value);
        break;
      case "first_academic_reference_email":
      case "second_academic_reference_email":
      case "first_bayan_reference_email":
      case "second_bayan_reference_email":
        regex =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        valid = regex.test(value);
        break;
      case "first_academic_reference_note":
      case "second_academic_reference_note":
      case "first_bayan_reference_note":
      case "second_bayan_reference_note":
        valid = true;
        break;
    }
    setState((prevState) => ({ ...prevState, [field + "Valid"]: valid }));
  };

  const validateForm = () => {
    let formData = state;
    let form =
      !!formData.waive_rightsValid &&
      !!formData.first_academic_reference_emailValid &&
      !!formData.first_bayan_reference_emailValid &&
      !!formData.second_academic_reference_emailValid &&
      !!formData.second_bayan_reference_emailValid &&
      !!formData.first_academic_reference_nameValid &&
      !!formData.second_academic_reference_nameValid &&
      !!formData.first_bayan_reference_nameValid &&
      !!formData.second_bayan_reference_nameValid;
    if (state.isFormDataValid != form) {
      setState((prevState) => ({ ...prevState, isFormDataValid: form }));
    }
  };
  return (
    <>
      <div className="app-form-container demographic residency">
        <div className="main-heading bayan-main-heading">
          {selectedProgramLabel}
        </div>
        <div className="sub-heading app-info">References</div>
        <div className="form-content">
          <div className="input-group">
            <div className="field-label">
              Privacy Waive for References*
              <br />
              <br />
              I waive my right to view references submitted for me.
              <br />
            </div>
            <div className="inline-f-b mt-20">
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.waive_rights == 1 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("waive_rights", 1);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("waive_rights", 1);
                    }}
                  >
                    Yes
                  </div>
                </div>
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.waive_rights == 0 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("waive_rights", 0);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("waive_rights", 0);
                    }}
                  >
                    No
                  </div>
                </div>
              </div>
            </div>
            {state.waive_rightsValid === false && (
              <div className="field-error">Must select a value.</div>
            )}
          </div>

          <div className="input-group">
            <div className="field-label">
              Please note that references cannot be close relatives or family
              members and must each be a unique person.
            </div>
          </div>

          <div className="input-group">
            <div className="field-label">
              <b>Academic Reference 1 *</b>
              <br />
              An academic reference can be a former professor, supervisor,
              advisor, or mentor that can speak to your ability to think
              critically, synthesize information, and overall do well in
              academic studies.
            </div>
            <br />
            <div className="field-label">Full Name of Reference #1</div>
            <input
              type="text"
              className={
                state.first_academic_reference_nameValid === false
                  ? "error"
                  : ""
              }
              value={state.formData.first_academic_reference_name}
              placeholder="Full Name"
              onChange={(e) => {
                updateForm("first_academic_reference_name", e.target.value);
              }}
            />
            {state.first_academic_reference_nameValid === false && (
              <div className="field-error">Must enter Name.</div>
            )}
            <br />
            <br />
            <div className="field-label">Email Address of reference #1</div>
            <input
              type="email"
              className={
                state.first_academic_reference_emailValid === false
                  ? "error"
                  : ""
              }
              value={state.formData.first_academic_reference_email}
              placeholder="Enter the email address of the person you would like to use as a reference"
              onChange={(e) => {
                updateForm("first_academic_reference_email", e.target.value);
              }}
            />
            {state.first_academic_reference_emailValid === false && (
              <div className="field-error">Must enter Email.</div>
            )}
            <div className="field-label mt-20">Personal Note (Optional)</div>
            <textarea
              value={state.formData.first_academic_reference_note}
              placeholder="Enter personal note here"
              onChange={(e) => {
                updateForm("first_academic_reference_note", e.target.value);
              }}
            />
            {/* <button className="send-btn">Send</button> */}
          </div>

          <div className="input-group">
            <div className="field-label">
              <b>Academic Reference 2*</b>
              <br />
              An academic reference can be a former professor, supervisor,
              advisor, or mentor that can speak to your ability to think
              critically, synthesize information, and overall do well in
              academic studies.
            </div>
            <br />
            <div className="field-label">Full Name of Reference #2</div>
            <input
              type="text"
              className={
                state.second_academic_reference_nameValid === false
                  ? "error"
                  : ""
              }
              value={state.formData.second_academic_reference_name}
              placeholder="Full Name"
              onChange={(e) => {
                updateForm("second_academic_reference_name", e.target.value);
              }}
            />
            {state.second_academic_reference_nameValid === false && (
              <div className="field-error">Must enter Name.</div>
            )}
            <br />
            <br />
            <div className="field-label">Email Address of reference #2</div>
            <input
              type="email"
              className={
                state.second_academic_reference_emailValid === false
                  ? "error"
                  : ""
              }
              value={state.formData.second_academic_reference_email}
              placeholder="Enter the email address of the person you would like to use as a reference"
              onChange={(e) => {
                updateForm("second_academic_reference_email", e.target.value);
              }}
            />
            {state.second_academic_reference_emailValid === false && (
              <div className="field-error">Must enter Email.</div>
            )}

            <div className="field-label mt-20">Personal Note (Optional)</div>
            <textarea
              value={state.formData.second_academic_reference_note}
              placeholder="Enter personal note here"
              onChange={(e) => {
                updateForm("second_academic_reference_note", e.target.value);
              }}
            />
          </div>

          <div className="input-group">
            <div className="field-label">
              <b>Community or Bayan Reference 1*</b>
              <br />A community reference can be a professional colleague,
              mentor, or community member.
            </div>
            <br />
            <div className="field-label">Full Name of Reference #1</div>
            <input
              type="text"
              className={
                state.first_bayan_reference_nameValid === false ? "error" : ""
              }
              value={state.formData.first_bayan_reference_name}
              placeholder="Full Name"
              onChange={(e) => {
                updateForm("first_bayan_reference_name", e.target.value);
              }}
            />
            {state.first_bayan_reference_nameValid === false && (
              <div className="field-error">Must enter Name.</div>
            )}
            <br />
            <br />
            <div className="field-label">
              Email address of community or bayan reference #1
            </div>
            <input
              type="email"
              className={
                state.first_bayan_reference_emailValid === false ? "error" : ""
              }
              value={state.formData.first_bayan_reference_email}
              placeholder="Enter the email address of the person you would like to use as a reference"
              onChange={(e) => {
                updateForm("first_bayan_reference_email", e.target.value);
              }}
            />
            {state.first_bayan_reference_emailValid === false && (
              <div className="field-error">Must enter Email.</div>
            )}

            <div className="field-label mt-20">Personal Note (Optional)</div>
            <textarea
              value={state.formData.first_bayan_reference_note}
              placeholder="Enter personal note here"
              onChange={(e) => {
                updateForm("first_bayan_reference_note", e.target.value);
              }}
            />

            {/* <button className="send-btn">Send</button> */}
          </div>

          <div className="input-group">
            <div className="field-label">
              <b>Community or Bayan Reference 2*</b>
              <br />A community reference can be a professional colleague,
              mentor, or community member.
            </div>
            <br />
            <div className="field-label">Full Name of Reference #2</div>
            <input
              type="text"
              className={
                state.second_bayan_reference_nameValid === false ? "error" : ""
              }
              value={state.formData.second_bayan_reference_name}
              placeholder="Full Name"
              onChange={(e) => {
                updateForm("second_bayan_reference_name", e.target.value);
              }}
            />
            {state.second_bayan_reference_nameValid === false && (
              <div className="field-error">Must enter Name.</div>
            )}
            <br />
            <br />
            <div className="field-label">
              Email address of community or bayan reference #2
            </div>
            <input
              type="email"
              className={
                state.second_bayan_reference_emailValid === false ? "error" : ""
              }
              value={state.formData.second_bayan_reference_email}
              placeholder="Enter the email address of the person you would like to use as a reference"
              onChange={(e) => {
                updateForm("second_bayan_reference_email", e.target.value);
              }}
            />
            {state.second_bayan_reference_emailValid === false && (
              <div className="field-error">Must enter Email.</div>
            )}

            <div className="field-label mt-20">Personal Note (Optional)</div>
            <textarea
              value={state.formData.second_bayan_reference_note}
              placeholder="Enter personal note here"
              onChange={(e) => {
                updateForm("second_bayan_reference_note", e.target.value);
              }}
            />
          </div>
        </div>

        <FormAction
          isFormDataValid={state.isFormDataValid}
          formData={state.formData}
          formStep={"references"}
          backStep={"transcripts"}
          nextStep={"applicationEssay"}
        />
      </div>
    </>
  );
}

// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default References;
